"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccount = exports.acquireToken = exports.msalInstance = exports.iffLoginRequest = void 0;
const msal_browser_1 = require("@azure/msal-browser");
exports.iffLoginRequest = {
    scopes: ["User.Read", process.env.REACT_APP_MSAL_SCOPE],
};
const iffTokenSilentRequest = {
    scopes: [process.env.REACT_APP_MSAL_SCOPE],
};
const configuration = {
    auth: {
        clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
        authority: process.env.REACT_APP_MSAL_AUTHORITY_URL,
        redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URL,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
};
exports.msalInstance = new msal_browser_1.PublicClientApplication(configuration);
async function acquireToken(instance, account) {
    const response = await instance.acquireTokenSilent({
        ...iffTokenSilentRequest,
        account,
    });
    if (response) {
        const { accessToken, expiresOn } = response;
        return {
            apiAccessToken: accessToken,
            apiAccessTokenExpiresOn: expiresOn || undefined,
        };
    }
}
exports.acquireToken = acquireToken;
// As not exported, similiar identify method of useAccount (https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/src/hooks/useAccount.ts).
function getAccount(allAccounts = [], accountIdentifiers) {
    if (allAccounts.length > 0 &&
        (accountIdentifiers.homeAccountId ||
            accountIdentifiers.localAccountId ||
            accountIdentifiers.username)) {
        const matchedAccounts = allAccounts.filter(accountObj => {
            if (accountIdentifiers.username &&
                accountIdentifiers.username.toLowerCase() !==
                    accountObj.username.toLowerCase()) {
                return false;
            }
            if (accountIdentifiers.homeAccountId &&
                accountIdentifiers.homeAccountId.toLowerCase() !==
                    accountObj.homeAccountId.toLowerCase()) {
                return false;
            }
            if (accountIdentifiers.localAccountId &&
                accountIdentifiers.localAccountId.toLowerCase() !==
                    accountObj.localAccountId.toLowerCase()) {
                return false;
            }
            return true;
        });
        return matchedAccounts[0] || null;
    }
    else {
        return null;
    }
}
exports.getAccount = getAccount;
